import { myStyleDark, myStyleLight } from "../dist/helpers";

const items = [
  {
    head: "Building software that scales with your business",
    body: "We share how we approach delivery with clear milestones, pragmatic architecture decisions, and measurable outcomes. This post highlights common pitfalls, plus the patterns we use to keep teams shipping with confidence.",
    date: "Aug 30, 2025",
    readTime: "5 min read",
    tag: "Delivery",
    tagColor: "#3b82f6",
  },
  {
    head: "Modernizing legacy systems without slowing teams down",
    body: "A practical guide to refactoring and cloud migration while maintaining uptime. Learn how we phase work, reduce risk, and keep stakeholders informed throughout the process.",
    date: "Sep 12, 2025",
    readTime: "7 min read",
    tag: "Architecture",
    tagColor: "#8b5cf6",
  },
].reverse();

export default function Insights({ finalIsDarkMode }) {
  const tc      = finalIsDarkMode ? "text-white" : "text-black";
  const mc      = finalIsDarkMode ? "text-white-50" : "text-muted";
  const surface = finalIsDarkMode ? myStyleDark : myStyleLight;
  const pageBg  = finalIsDarkMode
    ? { background: "#0d1526", minHeight: "100vh" }
    : { background: "#f1f5f9", minHeight: "100vh" };

  return (
    <div style={pageBg}>

      {/* ─── PAGE HERO ─────────────────────────────────────── */}
      <div
        className="page-hero"
        style={{ background: "linear-gradient(135deg, #1e3a8a 0%, #1d4ed8 50%, #0891b2 100%)" }}
      >
        <div style={{
          position: "absolute", top: "-30%", right: "-5%",
          width: 440, height: 440, borderRadius: "50%",
          background: "rgba(255,255,255,0.04)", pointerEvents: "none",
        }} />
        <div style={{
          position: "absolute", bottom: "-40%", left: "-5%",
          width: 320, height: 320, borderRadius: "50%",
          background: "rgba(255,255,255,0.03)", pointerEvents: "none",
        }} />
        <div className="container" style={{ position: "relative", zIndex: 1 }}>
          <span className="section-label" style={{ color: "#67e8f9" }}>Blog</span>
          <h1 className="display-5 fw-bold text-white mb-3">Insights</h1>
          <p className="text-white-50 mb-0" style={{ fontSize: "1.1rem", maxWidth: 520, lineHeight: 1.7 }}>
            Product, delivery, and technology perspectives from our team.
          </p>
        </div>
      </div>

      {/* ─── ARTICLES ──────────────────────────────────────── */}
      <div className="container py-5">
        <div className="row g-4">
          {items.map((item) => (
            <div key={item.head} className="col-12">
              <div className="p-5 rounded-3 card-hover" style={surface}>

                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-4">
                  <span className="tech-badge" style={{
                    background: `${item.tagColor}18`,
                    color: item.tagColor,
                    border: `1px solid ${item.tagColor}35`,
                    fontSize: 12,
                    padding: "4px 14px",
                    borderRadius: 100,
                  }}>
                    {item.tag}
                  </span>
                  <div className="d-flex align-items-center gap-3">
                    <span className={mc} style={{ fontSize: 13 }}>{item.readTime}</span>
                    <span className={mc} style={{ fontSize: 13 }}>{item.date}</span>
                  </div>
                </div>

                <h2 className={`fw-bold mb-3 ${tc}`} style={{ fontSize: "1.55rem", lineHeight: 1.3 }}>
                  {item.head}
                </h2>
                <p className={`mb-4 ${mc}`} style={{ lineHeight: 1.8, maxWidth: 720, fontSize: 20 }}>
                  {item.body}
                </p>

                <button className="btn btn-outline-primary btn-sm" style={{ borderRadius: 8 }}>
                  Read more &rarr;
                </button>

              </div>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
}
